import { render, staticRenderFns } from "./GuestCollection.vue?vue&type=template&id=70c8f6d0&scoped=true&"
import script from "./GuestCollection.vue?vue&type=script&lang=js&"
export * from "./GuestCollection.vue?vue&type=script&lang=js&"
import style0 from "./GuestCollection.vue?vue&type=style&index=0&id=70c8f6d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c8f6d0",
  null
  
)

export default component.exports